import {useContext} from "react";
import {programsContext} from "../providers/programsProvider";

export function usePrograms() {
    return useContext(programsContext);
}